import { render } from "./FlashInfo.vue?vue&type=template&id=e56c8c84&scoped=true"
import script from "./FlashInfo.vue?vue&type=script&lang=js"
export * from "./FlashInfo.vue?vue&type=script&lang=js"

import "./FlashInfo.vue?vue&type=style&index=0&id=e56c8c84&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e56c8c84"],['__file',"src/components/FlashInfo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e56c8c84"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e56c8c84', __exports__)) {
    api.reload('e56c8c84', __exports__)
  }
  
  module.hot.accept("./FlashInfo.vue?vue&type=template&id=e56c8c84&scoped=true", () => {
    api.rerender('e56c8c84', render)
  })

}


export default __exports__